import JobDescription from 'components/company/revamp/parts/setting/levelDescription/list';
import { useTranslation } from 'react-i18next';
import { useFetchJobDescGroup } from './useFetch';

function JobDesc() {
  const { t } = useTranslation();
  useFetchJobDescGroup();
  return (
    <JobDescription t={t} />
  );
}

export default JobDesc;
